import { useChains } from "@/hooks/useChains"
import { useConnectedChain } from "@/providers/Wallet/selectors"

export const useTransactionUrl = (txHash?: string): string | undefined => {
  const chain = useConnectedChain() ?? "ETHEREUM"
  const { getTransactionUrl } = useChains()

  if (!txHash) {
    return undefined
  }

  return getTransactionUrl(chain, txHash)
}
